import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20clean%20digital%20platform%20website%20hero%20background%20with%20abstract%20geometric%20shapes%2C%20warm%20orange%20and%20cream%20tones%2C%20soft%20gradient%2C%20professional%20tech%20atmosphere%2C%20minimalist%20design%2C%20light%20airy%20feel%2C%20no%20text&width=1600&height=800&seq=hero-91n-2026&orientation=landscape"
        alt="91n.com 官方平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="91n.com 官方入口"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/40"></div>
      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight">
            91n.com 官方入口
          </h2>
          <p className="mt-5 text-base md:text-lg text-background-50/80 leading-relaxed max-w-2xl mx-auto">
            值得信赖的网络综合服务平台 —— 全面了解 91n.com 的官方入口、核心功能、使用指南及常见问题解答
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/feature-guide"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              探索功能
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-background-50/15 text-background-50 border border-background-50/30 rounded-md font-medium text-sm hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}